export enum EnaioConvertEmptyValuesMode {
    dataTypeDefault = 0,
    emptyString = 1,
    setNull = 2
}
export namespace EnaioConvertEmptyValuesMode{
    export function getName(value: EnaioConvertEmptyValuesMode): string {
        switch (value) {
            case EnaioConvertEmptyValuesMode.dataTypeDefault:
                return "dataTypeDefault";
            case EnaioConvertEmptyValuesMode.emptyString:
                return "emptyString";
            case EnaioConvertEmptyValuesMode.setNull:
                return "setNull";
        }
    }
}
